import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function Level5Illustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3649">
      <div className="relative w-full h-full bg-gradient-to-b from-green-200 to-emerald-400 overflow-hidden" data-id="element-3650">
        {/* Background: Garden/Nature */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3651">
          {/* Bushes */}
          <circle cx="30" cy="140" r="40" fill="#22C55E" data-id="element-3652" />
          <circle cx="60" cy="150" r="35" fill="#16A34A" data-id="element-3653" />
          <circle cx="170" cy="130" r="45" fill="#22C55E" data-id="element-3654" />
          <circle cx="140" cy="150" r="30" fill="#16A34A" data-id="element-3655" />

          {/* Sun */}
          <circle cx="160" cy="40" r="25" fill="#FEF08A" data-id="element-3656" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[10%]" data-id="element-3657">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3658">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'excited' : 'thinking'} variant={variant} accessory="leafGarland" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3659" />
          </div>
        </div>

        {/* Foreground: Leaves and Flowers */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3660">
            {/* Floating leaves */}
            <path d="M40 60 Q50 50 60 60 Q50 70 40 60 Z" fill="#86EFAC" transform="rotate(15 50 60)" data-id="element-3661" />
            <path d="M140 80 Q150 70 160 80 Q150 90 140 80 Z" fill="#4ADE80" transform="rotate(-25 150 80)" data-id="element-3662" />
            <path d="M20 100 Q30 90 40 100 Q30 110 20 100 Z" fill="#86EFAC" transform="rotate(45 30 100)" data-id="element-3663" />

            {/* Flowers */}
            <g transform="translate(30, 160) scale(0.5)" data-id="element-3664">
              <circle cx="0" cy="-10" r="8" fill="#F472B6" data-id="element-3665" />
              <circle cx="10" cy="0" r="8" fill="#F472B6" data-id="element-3666" />
              <circle cx="0" cy="10" r="8" fill="#F472B6" data-id="element-3667" />
              <circle cx="-10" cy="0" r="8" fill="#F472B6" data-id="element-3668" />
              <circle cx="0" cy="0" r="6" fill="#FDE047" data-id="element-3669" />
            </g>

            <g transform="translate(170, 170) scale(0.6)" data-id="element-3670">
              <circle cx="0" cy="-10" r="8" fill="#60A5FA" data-id="element-3671" />
              <circle cx="10" cy="0" r="8" fill="#60A5FA" data-id="element-3672" />
              <circle cx="0" cy="10" r="8" fill="#60A5FA" data-id="element-3673" />
              <circle cx="-10" cy="0" r="8" fill="#60A5FA" data-id="element-3674" />
              <circle cx="0" cy="0" r="6" fill="#FDE047" data-id="element-3675" />
            </g>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}